import { uiConstants } from '../constants/uiConstants';

function sidebarState() {
  return (dispatch) => {
    dispatch({ type: uiConstants.COMMENT_SIDEBAR });
  };
  // function success(value) { return { type: uiConstants.COMMENT_SIDEBAR, value} }
}

const uiActions = {
  sidebarState,
};

export default uiActions;
